import { useState, useEffect, useMemo } from "react"

import Select from "react-select";

import Box from '@mui/material/Box';

import Slider from '@mui/material/Slider';

import { useUser } from "../utils/UserContext";

import { toast } from 'react-hot-toast';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { formatCurrency } from '../utils/currencyUtils';

import { GaugeComponent } from 'react-gauge-component';

const marks = [

  {

    value: 0,

    label: '0%',

  },

  {

    value: 20,

    label: '20%',

  },

  {

    value: 50,

    label: '50%',

  },

  {

    value: 75,

    label: '75%',

  },

  {

    value: 100,

    label: '100%',

  },

];

function valuetext(value) {

  return `${value}%`;

}

function FuturesTradeForm({ trade, type, setTrade, setType }) {

  const { user } = useUser();

  const [tradeTab, setTradeTab] = useState("limit");

  const [error, setError] = useState(false);

  const usdbal = user?.usdtbalance;

  const [tradeDetails, setTradeDetails] = useState([]);

  const [loading, setLoading] = useState(false);

  const [loading1, setLoading1] = useState(false);

  const [loading2, setLoading2] = useState(false);

  const leverageoptions = [

    { label: "1x", value: 1 },

    { label: "3x", value: 3 },

    { label: "5x", value: 5 },

    { label: "10x", value: 10 },

    { label: "50x", value: 50 },

  ];

  const typeoptions = [

    { value: "isolated", label: "Isolated" },

    { value: "cross", label: "Cross" },

  ];

  const darkThemeStyles = {

    control: (styles) => ({

      ...styles,

      backgroundColor: "#151719",

      border: "none",

      color: "#fff",

    }),

    menu: (styles) => ({

      ...styles,

      backgroundColor: "#151719",

    }),

    option: (styles, { isFocused, isSelected }) => ({

      ...styles,

      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",

      color: "#fff",

    }),

    singleValue: (styles) => ({

      ...styles,

      color: "#fff",

    }),

  };

  const [coinbal, setCoinbal] = useState([]);

  const [crypto, setCrypto] = useState([]);    

  const [wallet, setWallet] = useState([]);

  useEffect(() => {

    if (!user?.id) return;

    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {

      credentials: "include",

      method: "POST",

      headers: {

        "Content-Type": "application/json"

      },

      body: JSON.stringify({ fetchwallet: true })

    })

    .then(response => response.json())

    .then(data => {

      if (data.status === "success") {

        setWallet(data.wallet || []);

      }

    })

    .catch(err => {

    })

  }, [user?.id]);

  useEffect(() => {

      fetch(`/coin_list.txt`)

      .then((res) => res.json())

      .then((data) => {

      var coinList = data.data.sort((a, b) => a.name.localeCompare(b.name));

      const updatedData = coinList.map((coin, index) => {

        const walletItem = wallet.find(item => item.coinName === coin.name);

        return {

          id: index + 1,

          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,

          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,

          coin_id: coin.id,

          name: coin.name,

          symbol: coin.symbol,

          price: Number(coin.quote.USD.price),

          percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2)),

          value: coin.symbol,

          balance: walletItem ? walletItem.balance : 0,

        };

      });

      setCrypto(updatedData);

      })

      .catch((err) => console.error("Error loading coin list:", err));

  }, [wallet]);

  useEffect(() => {

    const found = crypto.find(opt => opt.value === trade) || null;

    setTradeDetails(found)

    setPrice(found?.price)

    setCoinbal(found?.balance ?? 0);

  }, [crypto, trade]);

  const [leverage, setLeverage] = useState(10);

  const [pattern, setPattern] = useState('isolated');

  const [price, setPrice] = useState(0);

  // This state now represents the user's Margin input.
  const [order, setOrder] = useState(0);

  const [costper, setCostper] = useState(0);

  const [tp, setTP] = useState(0);

  const [sl, setSL] = useState(0);

  const isDisabled = !(order > 0 && price > 0 && pattern && leverage && !error);

  const isDisabled1 = !(order > 0 && pattern && leverage && !error);

  const isDisabled2 = !(order > 0 && price > 0 && pattern && leverage && tp && sl && !error);

  function handleOrderFromPercent(val) {

    const perc = Array.isArray(val) ? val[0] : val;

    const safePerc = Math.max(0, Math.min(100, Number(perc) || 0));

    const balance = Number(usdbal) || 0;

    // Slider represents a percentage of the available balance as Margin.
    const nextCost = Number(

      (balance * (safePerc / 100)).toFixed(2)

    );

    if (order !== nextCost) setOrder(nextCost);

    if (costper !== safePerc) setCostper(safePerc);

  }

  function handleCostChange(val) {

    const n = Number(val);

    const nextCost = Number.isFinite(n) ? n : 0;

    // The input is Margin.
    if (order !== nextCost) setOrder(nextCost);

    const usd = Number(usdbal) || 0;

    // Slider percentage is based on Margin / available balance.
    const nextPer = usd ? Number(((nextCost / usd) * 100).toFixed(2)) : 0;

    if (costper !== nextPer) setCostper(nextPer);

  }

  function handlePriceChange(val) {

    const n = Number(val);

    const nextPrice = Number.isFinite(n) ? n : 0;

    if (price !== nextPrice) setPrice(nextPrice);

  }

  function handleLimit(direction){

    if(direction == "Short"){

      setLoading(true);

    }else{

      setLoading2(true);

    }

    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {

      credentials: "include",

      method: "POST",

      headers: {

        "Content-Type": "application/json"

      },

      body: JSON.stringify({
        btn_limit: true,
        price : price,
        orderval : orderValue,
        leverageInput : leverage,
        futuretypeInput : pattern,
        type : direction,
        coin_id : tradeDetails.coin_id
      })

    })

    .then(response => response.json())

    .then(data => {

      if (data.status === "success") {

        toast.success(data.result);

        setTimeout(() => {

          window.location.reload();

        }, 1500);

      }else{

        toast.error(data.message);

      }

      setLoading(false);

      setLoading2(false);

    })

    .catch(err => {

      console.error(err)

      setLoading(false);

      setLoading2(false);

    })

  }

  function handleMarket(direction){

    if(direction == "Short"){

      setLoading(true);

    }else{

      setLoading2(true);

    }

    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {

      credentials: "include",

      method: "POST",

      headers: {

        "Content-Type": "application/json"

      },

      body: JSON.stringify({
        btn_market: true,
        price : tradeDetails.price,
        orderval : orderValue,
        leverageInput : leverage,
        futuretypeInput : pattern,
        type : direction,
        coin_id : tradeDetails.coin_id
      })

    })

    .then(response => response.json())

    .then(data => {

      if (data.status === "success") {

        toast.success(data.result);

        setTimeout(() => {

          window.location.reload();

        }, 1500);

      }else{

        toast.error(data.message);

      }

      setLoading(false);

      setLoading2(false);

    })

    .catch(err => {

      console.error(err)

      setLoading(false);

      setLoading2(false);

    })

  }

  function handleTPSL(direction){

    if(direction == "Short"){

      setLoading(true);

    }else{

      setLoading2(true);

    }

    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {

      credentials: "include",

      method: "POST",

      headers: {

        "Content-Type": "application/json"

      },

      body: JSON.stringify({
        btn_tpsl: true,
        price : tradeDetails.price,
        orderval : orderValue,
        leverageInput : leverage,
        futuretypeInput : pattern,
        type : direction,
        coin_id : tradeDetails.coin_id,
        tp : tp,
        sl : sl
      })

    })

    .then(response => response.json())

    .then(data => {

      if (data.status === "success") {

        toast.success(data.result);

        setTimeout(() => {

          window.location.reload();

        }, 1500);

      }else{

        toast.error(data.message);

      }

      setLoading(false);

      setLoading2(false);

    })

    .catch(err => {

      console.error(err)

      setLoading(false);

      setLoading2(false);

    })

  }

  /*
   * Order Value is now calculated from Margin.
   *
   * Example:
   * Margin = 100
   * Leverage = 10x
   * Order Value = 1000
   */

  const orderValue = useMemo(() => {

    const margin = Number(order) || 0;

    const lev = Math.max(Number(leverage) || 1, 1);

    if (margin <= 0) return 0;

    return Number((margin * lev).toFixed(2));

  }, [order, leverage]);

  /*
   * Quantity is calculated from Order Value, not Margin.
   *
   * Qty = Order Value / Price
   */

  const qty = useMemo(() => {

    const positionSize = Number(orderValue) || 0;

    const marketPrice = Number(price) || 0;

    if (positionSize <= 0 || marketPrice <= 0) return 0;

    return Number((positionSize / marketPrice).toFixed(6));

  }, [orderValue, price]);

  /*
   * Cost now represents the Margin entered by the user.
   */

  const cost = useMemo(() => {

    const margin = Number(order) || 0;

    if (margin <= 0) return 0;

    return Number(margin.toFixed(2));

  }, [order]);

  useEffect(() => {
    const bal = Number(usdbal) || 0;
    // Balance validation is based on Margin.
    const nextError = cost > bal || bal === 0;
    if (error !== nextError) setError(nextError);
  }, [cost, usdbal, error]);
  const [futurePL, setFuturePL] = useState({});

  const riskPer = useMemo(() => {
    const value = Number(futurePL?.riskper);
    if (!Number.isFinite(value)) return 0;
    return Math.min(100, Math.max(0, value));
  }, [futurePL?.riskper]);

  useEffect(() => {

    const coinId = tradeDetails?.coin_id;

    if (!user?.id || !coinId) return;

    const fetchFutures = () => {

      fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {

        credentials: "include",

        method: "POST",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({ fetchfutures: true })

      })

        .then(r => r.json())

        .then(data => {

          if (data.status === "success") {
            console.log(data.data);
            setFuturePL(data.data);

          }

        })

        .catch(() => {});

    };

    fetchFutures();

    const interval = setInterval(fetchFutures, 5000);

    return () => clearInterval(interval);

  }, [user?.id, tradeDetails?.coin_id]);

  function CloseAll(){

    setLoading1(true);

    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {

      credentials: "include",

      method: "POST",

      headers: {

        "Content-Type": "application/json"

      },

      body: JSON.stringify({ closeAll: true})

    })

    .then(response => response.json())

    .then(data => {

      if (data.status === "success") {

        toast.success(data.result);

        setTimeout(() => {

          window.location.reload();

        }, 1500);

      }else{

        toast.error(data.message);

      }

      setLoading1(false);

    })

    .catch(err => {

      console.error(err)

      setLoading1(false);

    })

  }

  if (!tradeDetails) {

    return <div style={{ textAlign: "center", marginTop: "20%", marginBottom: "20%"}}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;

  }

  return (

    <div className="mycard mt-2 futurecard p-2 p-md-3 position-relative">

        <div className="d-flex align-items-center justify-content-between">

          <Select 

              options={typeoptions} 

              value={typeoptions.find((opt) => opt.value === pattern)}

              onChange={(e) => {setPattern(e.value);}}

              styles={darkThemeStyles}

              className="w-49"

          />

          <Select 

              options={leverageoptions} 

              value={leverageoptions.find((opt) => opt.value === leverage)}

              onChange={(e) => {setLeverage(e.value);}}

              styles={darkThemeStyles}

              className="w-49"

          />

        </div>

        <div className="d-flex align-items-center justify-content-between my-md-2 my-1">

            <p className="mb-0" style={{fontSize:'14px'}}>Avl. bal.</p>

            <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{formatCurrency(usdbal)} USDT</p>

        </div>

        <div className="mytab justify-content-between">

          <div className={`mytab-item1 buy ${tradeTab === "limit" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {

            setTradeTab("limit")}}>LIMIT</div>

          <div className={`mytab-item1 buy ${tradeTab === "market" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {

            setTradeTab("market")}}>MARKET</div>

          <div className={`mytab-item1 buy ${tradeTab === "tpsl" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {

            setTradeTab("tpsl")}}>TP/SL</div>

        </div>

        {tradeTab === "limit" && (

        <div className="mt-md-2">

          <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Price (USDT)</label>

            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

            <input

              type="number"

              placeholder={tradeDetails?.price ? formatCurrency(tradeDetails.price - ((0.74/100) * tradeDetails.price)) : '0.00'}

              className="inputNone"

              value={price === 0 ? '' : price}

              onChange={(e) => handlePriceChange(e.target.value)}

            />

            <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>USDT</div>

          </div>

          <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Margin (USDT)</label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

            <input

              type="number"

              placeholder="0.00"

              className="inputNone"

              value={order === 0 ? '' : order}

              onChange={(e) => handleCostChange(e.target.value)}

            />

            <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>USDT</div>

          </div>

          <Box sx={{ width: '100%', paddingLeft:'10px', paddingRight:'10px', marginTop: '30px' }}>

            <Slider

              aria-label="Margin percent"

              value={costper}

              onChange={(e, v) => handleOrderFromPercent(v)}

              getAriaValueText={valuetext}

              step={5}

              marks={marks}

              valueLabelDisplay="on"

              sx={{

                color: "#ff6b35",

                "& .MuiSlider-thumb": {

                  backgroundColor: "#ff6b35", 

                  border: "5px solid #ff6b35",

                  borderRadius: '3px'

                },

                "& .MuiSlider-thumb:before": {

                  boxShadow: 'none'

                },

                "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {

                  boxShadow: "0px 0px 0px 8px rgba(248, 156, 123, 0.2)",

                },

                "& .MuiSlider-track": {

                  backgroundColor: "#ff6b35",

                  height: '10px'

                },

                "& .MuiSlider-rail": {

                  backgroundColor: "#ffffff80",

                  opacity: 1,

                  height: '10px'

                },

                "& .MuiSlider-valueLabel": {

                  backgroundColor: "#ff6b35",

                  color: "#fff",

                  borderRadius: "4px",

                },

                "& .MuiSlider-mark": {

                  backgroundColor: "#000000ff",

                  width: '5px',

                  height: '8px',

                  borderRadius: '4px'

                },

                "& .MuiSlider-markActive": {

                  backgroundColor: "#ff6b35",

                },

                "& .MuiSlider-markLabel": {

                  color: "#ffffffff",

                  fontWeight: '600'

                },

                "& .MuiSlider-markLabelActive": {

                  color: "#ff6b35",

                },

              }}

            />

          </Box>

          {error && (

          <p className="mb-0 text-danger fs-7 mt-1">You’re trying to trade {cost} USDT, but your available balance is {formatCurrency(usdbal)} USDT. Please enter an amount less than or equal to your balance.</p>

          )}

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Qty</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{qty}</span> / <span className="text-danger">{qty}</span> {trade}</p>

            </div>

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Order Value</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{orderValue}</span> / <span className="text-danger">{orderValue}</span> USDT</p>

            </div>

          </div>

          <div className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${isDisabled?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled ? () => handleLimit("Long") : undefined}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Long'}</div>

          <div className={`myBtn bg-danger w-100 text-center mt-2 ${isDisabled?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled ? () => handleLimit("Short") : undefined}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Short'}</div>

        </div>

        )}

        {tradeTab === "market" && (

        <div className="mt-md-2">

          <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Margin (USDT)</label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

            <input

              type="number"

              placeholder="0.00"

              className="inputNone"

              value={order === 0 ? '' : order}

              onChange={(e) => handleCostChange(e.target.value)}

            />

            <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>USDT</div>

          </div>

          <Box sx={{ width: '100%', paddingLeft:'10px', paddingRight:'10px', marginTop: '30px' }}>

            <Slider

              aria-label="Margin percent"

              value={costper}

              onChange={(e, v) => handleOrderFromPercent(v)}

              getAriaValueText={valuetext}

              step={5}

              marks={marks}

              valueLabelDisplay="on"

              sx={{

                color: "#ff6b35",

                "& .MuiSlider-thumb": {

                  backgroundColor: "#ff6b35", 

                  border: "5px solid #ff6b35",

                  borderRadius: '3px'

                },

                "& .MuiSlider-thumb:before": {

                  boxShadow: 'none'

                },

                "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {

                  boxShadow: "0px 0px 0px 8px rgba(248, 156, 123, 0.2)",

                },

                "& .MuiSlider-track": {

                  backgroundColor: "#ff6b35",

                  height: '10px'

                },

                "& .MuiSlider-rail": {

                  backgroundColor: "#ffffff80",

                  opacity: 1,

                  height: '10px'

                },

                "& .MuiSlider-valueLabel": {

                  backgroundColor: "#ff6b35",

                  color: "#fff",

                  borderRadius: "4px",

                },

                "& .MuiSlider-mark": {

                  backgroundColor: "#000000ff",

                  width: '5px',

                  height: '8px',

                  borderRadius: '4px'

                },

                "& .MuiSlider-markActive": {

                  backgroundColor: "#ff6b35",

                },

                "& .MuiSlider-markLabel": {

                  color: "#ffffffff",

                  fontWeight: '600'

                },

                "& .MuiSlider-markLabelActive": {

                  color: "#ff6b35",

                },

              }}

            />

          </Box>

          {error && (

          <p className="mb-0 text-danger fs-7 mt-1">You’re trying to trade {cost} USDT, but your available balance is {formatCurrency(usdbal)} USDT. Please enter an amount less than or equal to your balance.</p>

          )}

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Qty</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{qty}</span> / <span className="text-danger">{qty}</span> {trade}</p>

            </div>

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Order Value</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{orderValue}</span> / <span className="text-danger">{orderValue}</span> USDT</p>

            </div>

          </div>

          <div className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${isDisabled1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled1 ? () => handleMarket("Long") : undefined}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Long'}</div>

          <div className={`myBtn bg-danger w-100 text-center mt-2 ${isDisabled1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled1 ? () => handleMarket("Short") : undefined}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Short'}</div>

        </div>

        )}

        {tradeTab === "tpsl" && (

          <div className="mt-md-2">

          <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Price (USDT)</label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

          <input

            type="number"

            placeholder={tradeDetails?.price ? formatCurrency(tradeDetails.price - ((0.74/100) * tradeDetails.price)) : '0.00'}

            className="inputNone"

            value={price === 0 ? '' : price}

            onChange={(e) => handlePriceChange(e.target.value)}

          />

          <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>USDT</div>

          </div>

          <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Margin (USDT)</label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

            <input

              type="number"

              placeholder="0.00"

              className="inputNone"

              value={order === 0 ? '' : order}

              onChange={(e) => handleCostChange(e.target.value)}

            />

            <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>USDT</div>

          </div>

          <Box sx={{ width: '100%', paddingLeft:'10px', paddingRight:'10px', marginTop: '30px' }}>

            <Slider

              aria-label="Margin percent"

              value={costper}

              onChange={(e, v) => handleOrderFromPercent(v)}

              getAriaValueText={valuetext}

              step={5}

              marks={marks}

              valueLabelDisplay="on"

              sx={{

                color: "#ff6b35",

                "& .MuiSlider-thumb": {

                  backgroundColor: "#ff6b35", 

                  border: "5px solid #ff6b35",

                  borderRadius: '3px'

                },

                "& .MuiSlider-thumb:before": {

                  boxShadow: 'none'

                },

                "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {

                  boxShadow: "0px 0px 0px 8px rgba(248, 156, 123, 0.2)",

                },

                "& .MuiSlider-track": {

                  backgroundColor: "#ff6b35",

                  height: '10px'

                },

                "& .MuiSlider-rail": {

                  backgroundColor: "#ffffff80",

                  opacity: 1,

                  height: '10px'

                },

                "& .MuiSlider-valueLabel": {

                  backgroundColor: "#ff6b35",

                  color: "#fff",

                  borderRadius: "4px",

                },

                "& .MuiSlider-mark": {

                  backgroundColor: "#000000ff",

                  width: '5px',

                  height: '8px',

                  borderRadius: '4px'

                },

                "& .MuiSlider-markActive": {

                  backgroundColor: "#ff6b35",

                },

                "& .MuiSlider-markLabel": {

                  color: "#ffffffff",

                  fontWeight: '600'

                },

                "& .MuiSlider-markLabelActive": {

                  color: "#ff6b35",

                },

              }}

            />

          </Box>

          {error && (

          <p className="mb-0 text-danger fs-7 mt-1">You’re trying to trade {cost} USDT, but your available balance is {formatCurrency(usdbal)} USDT. Please enter an amount less than or equal to your balance.</p>

          )}

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Qty</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{qty}</span> / <span className="text-danger">{qty}</span> {trade}</p>

            </div>

            <div className="d-flex align-items-center justify-content-between">

                <p className="mb-0 text-white" style={{fontSize:'14px'}}>Order Value</p>

                <p className="mb-0" style={{fontSize:'14px'}}><span className="text-success">{orderValue}</span> / <span className="text-danger">{orderValue}</span> USDT</p>

            </div>

          </div>

          <div className="d-flex align-items-center justify-content-between mt-2">

            <div style={{width: '49%'}}>

              <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Stop Loss:</label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

                <input 

                  type="text" 

                  placeholder={formatCurrency(tradeDetails.price - ((0.74/100) * tradeDetails.price))}

                  className="inputNone"

                  value={sl}

                  onChange={(e) => setSL(e.target.value)}

                />

                <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>{trade}</div>

              </div>

            </div>

            <div style={{width: '49%'}}>

              <label className="fw-semibold mb-1 mt-md-2 mt-1" style={{fontSize: '14px'}}>Take Profit:</label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">

                <input 

                  type="text" 

                  placeholder={formatCurrency(tradeDetails.price + ((0.74/100) * tradeDetails.price))}

                  className="inputNone"

                  value={tp}

                  onChange={(e) => setTP(e.target.value)}

                />

                <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px'}}>{trade}</div>

              </div>

            </div>

          </div>

          <div className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${isDisabled2?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled2 ? () => handleTPSL("Long") : undefined}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Long'}</div>

          <div className={`myBtn bg-danger w-100 text-center mt-2 ${isDisabled2?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!isDisabled2 ? () => handleTPSL("Short") : undefined}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Short'}</div>

        </div>

        )}

        <div className="d-flex align-items-cenetr justify-content-center">

          <div className="position-relative mx-auto" style={{maxWidth:'250px',width:'100%'}}>

            <GaugeComponent

              type="semicircle"

              minValue={0}

              maxValue={100}

              arc={{

                colorArray: ['#00FF15', '#FF2121'],

                padding: 0,

                subArcs: [

                  { limit: 10 },

                  { limit: 20 },

                  { limit: 40 },

                  { limit: 60 },

                  { limit: 80 },

                  { limit: 90 },

                  { limit: 100 }

                ]

              }}

              pointer={{ type: "blob", animationDelay: 1 }}

              value={riskPer}

            />
            <p
              className={`mb-0 position-absolute fw-semibold text-uppercase fw-bold ${
                riskPer > 50
                  ? "text-danger"
                  : riskPer >= 25
                    ? "text-warning"
                    : "text-success"
              }`}
              style={{
                bottom: "4%",
                transform: "translateX(-50%)",
                left: "50%",
                fontSize: "14px"
              }}
            >
              {riskPer > 50
                ? "Risk"
                : riskPer >= 25
                  ? "Low Risk"
                  : "No Risk"}
            </p>

          </div>

        </div>

        <div className="d-flex align-items-center justify-content-between" style={{marginTop:'-5px'}}>

              <p className="mb-0 text-white" style={{fontSize:'14px'}}>Total Margin:</p>

              <p className="mb-0" style={{fontSize:'14px'}}>{formatCurrency(futurePL.totalMargin)} USDT</p>

        </div>

        <div className="d-flex align-items-center justify-content-between">

              <p className="mb-0 text-white" style={{fontSize:'14px'}}>Total P/L:</p>

              <p className="mb-0" style={{fontSize:'14px'}}>{futurePL.totalPandL > 0 ? '+' : '-'}{formatCurrency(futurePL.totalPandL)} USDT</p>

        </div>

        <div className="mt-3 myBtn bg-success fw-semibold d-inline-block" style={{fontSize:'14px', cursor:'pointer'}} onClick={()=> CloseAll()}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'CLOSE ALL'}</div>

    </div>

    )

  }

  export default FuturesTradeForm